// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Domine', 'Domine Fallback'","fontStyle":"normal"},"className":"__className_937605"};